<app-dialog
  #dialog
  [key]="'meeting-agent-runs'"
  [action]="'meeting-agent-runs'"
  [headerTheme]="'simple'"
  [title]="'Sessões do Cog'"
  [maxWidth]="'760px'">
  <div class="runs">
    <p class="runs__intro">
      O que os agentes do Cog fizeram nesta reunião, para inspeção do time interno. Custos em dólar,
      como o provedor cobra.
    </p>

    @for (run of runs() ?? []; track run.agent) {
      <section class="runs__card" [class.runs__card--failed]="run.status === 'Failed'">
        <header class="runs__head">
          <strong>{{ rotuloDoAgente(run.agent) }}</strong>
          <span [class]="'runs__status runs__status--' + run.status">
            {{ rotuloDaSituacao(run.status) }}
          </span>
          @if (podeAbrirSessao() && run.sessionId) {
            <app-button
              [label]="'Abrir sessão'"
              [icon]="'pi pi-external-link'"
              [theme]="'outline-grey'"
              [size]="'small'"
              [type]="'button'"
              (sendButtonClick)="abrirSessao(run)" />
          }
        </header>

        @if (run.error) {
          <p class="runs__error" role="alert">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i> {{ run.error }}
          </p>
        }

        <dl class="runs__facts">
          <div>
            <dt>Modelo</dt>
            <dd>{{ run.model || '-' }}</dd>
          </div>
          <div>
            <dt>Tokens (entrada / saída)</dt>
            <dd>{{ tokens(run) }}</dd>
          </div>
          <div>
            <dt>Custo</dt>
            <dd>{{ custo(run.costUsd) }}</dd>
          </div>
          <div>
            <dt>Duração</dt>
            <dd>{{ duracao(run.durationMs) }}</dd>
          </div>
          <div>
            <dt>Chamadas de tool</dt>
            <dd>{{ run.toolCalls ?? '-' }}</dd>
          </div>
          <div>
            <dt>Tentativas</dt>
            <dd>{{ run.attempts ?? '-' }}</dd>
          </div>
          <div>
            <dt>Prompt / agente</dt>
            <dd>{{ run.promptVersion || '-' }} · {{ run.agentVersion || '-' }}</dd>
          </div>
          <div>
            <dt>Pedido em</dt>
            <dd>{{ run.requestedAt ? (run.requestedAt | vaultDateTime) : '-' }}</dd>
          </div>
          <div>
            <dt>Terminou em</dt>
            <dd>{{ run.finishedAt ? (run.finishedAt | vaultDateTime) : '-' }}</dd>
          </div>
        </dl>

        @if (run.jobKey) {
          <p class="runs__job" [title]="run.jobKey">
            Job {{ run.jobKey }}
            @if (run.jobStatus) {
              · {{ run.jobStatus }}
            }
            @if (run.lastPhase) {
              · {{ run.lastPhase }}
            }
          </p>
        }
      </section>
    } @empty {
      <p class="runs__intro">Nenhum agente rodou nesta reunião ainda.</p>
    }

    @if (algumFalhou() && podeGerar()) {
      <div class="runs__retry">
        <span>Um dos agentes falhou. Gerar de novo refaz os dois numa rodada nova.</span>
        <app-button
          [label]="'Gerar de novo'"
          [icon]="'pi pi-refresh'"
          [size]="'small'"
          [type]="'button'"
          [isLoading]="gerando()"
          (sendButtonClick)="gerar.emit()" />
      </div>
    }
  </div>
</app-dialog>
